import { API } from "../config/AppConfig";
import { DASHBOARD_TILES_CLICK_STATS } from "../constants/Endpoints";
import { replaceRoute } from "../utils/common.utils";

class ClientPreferenceStatsRepository {
    async getTilesClickHistoryData(cqUserId) {
        const res = await API.get(DASHBOARD_TILES_CLICK_STATS, {
            pathParams: { cqUserId }
        })
    }

    setTilesClickHistoryData(queryParams, payload, isFinal = false) {
        // for the periodic api request 
        if (!isFinal) {
            API.post(DASHBOARD_TILES_CLICK_STATS, {
                body: {'data': payload, ...queryParams},
            })
        } else {
            // for api request when moving away from the page or refreshing or closing the browser
            // for brave ad blockers is causing issue, so fetch is used, even though it's not robust
            if (!!navigator.brave) {
                fetch(DASHBOARD_TILES_CLICK_STATS, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ data: payload, ...queryParams }),
                    keepalive: true
                  });
            } else {
                navigator.sendBeacon(DASHBOARD_TILES_CLICK_STATS,
                    JSON.stringify({'data' : payload, ...queryParams}));
                }
            
        }
        
    }

}

const clientPreferenceStatsRepository = new ClientPreferenceStatsRepository();
export default clientPreferenceStatsRepository;